
export async function FetchRetry(promise, n = 2, onErrMsg = "401") {
    return new Promise(function (resolve, reject){
        promise().then(resolve).catch((err) => {
            if (err.message === onErrMsg){
                if (n === 1 ) return reject(err);
                resolve(FetchRetry(promise, n - 1))
            }
            return reject(err)
        })
    })
}